import React from 'react';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import {apiBaseUrl} from './Config';

import './Login.css';

class Login extends React.Component {
    constructor(props) {
	super(props);
	
	this.state = {
	    username: "",
	    password: "",
	    error: ""
	};

	this.resource = apiBaseUrl + "sessions";

	this.handleChange = this.handleChange.bind(this);
	this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
	this.setState({[event.target.name]: event.target.value});
    }

    handleSubmit(event) {
	const data = {
	    username: this.state.username,
	    password: this.state.password
	};

	fetch(this.resource, {
	    method: "POST",
	    headers: {
		"Content-Type": "application/json"
	    },
	    body: JSON.stringify(data)
	})
	    .then((response) => {
		if (!response.ok) {
		    throw new Error("Kunde inte logga in");
		}
		
		return response.json();
	    })
	    .then((result) => {
		this.props.onLoggedIn({
		    username: this.state.username,
		    userid: result.id,
		    level: result.level,
		    token: result.token
		});
	    })
	    .catch((error) => {
		this.setState({error: error.message});
	    });
	
	event.preventDefault();
    }
    
    render() {
	return (
	    <Container>
		<Row>
		    <Col sm="4">
		    </Col>
		    <Col>
			<p>
			    V&auml;lkommen till &Auml;ventyrskursens alumni-sidor!
			</p>
			<p>
			    Dessa sidor &auml;r tillg&auml;ngliga f&ouml;r alla &Auml;fventyrsm&auml;stare, dvs. alla som har genomg&aring;tt Vargarnas &Auml;ventyrskurs och erh&aring;llit m&auml;starbref.
			</p>

			<hr />

			<Form onSubmit={this.handleSubmit}>
			    <div className="d-flex justify-content-center">
				<Form.Text className="error">{this.state.error} &nbsp;</Form.Text>
			    </div>
			    <br />
			    <Form.Group>
				<Form.Label>Email:</Form.Label>
				<Form.Control name="username" type="email" placeholder="Skriv in emailadress" autoFocus value={this.state.username} onChange={this.handleChange} />
			    </Form.Group>
			    
			    <br />
			    
			    <Form.Group>
				<Form.Label>L&ouml;senord:</Form.Label>
				<Form.Control name="password" type="password" placeholder="Skriv in l&ouml;senord" value={this.state.password} onChange={this.handleChange} />
			    </Form.Group>
			    
			    <br />

			    <div className="d-flex justify-content-center">
				<Button variant="alumni" type="submit">Logga in</Button>
			    </div>
			</Form>

			<hr />
		    </Col>
		    <Col sm="4">
		    </Col>
		</Row>
	    </Container>
	);
    }
}

export default Login;
